module.exports = __webpack_public_path__ + "static/media/JuliaPalacios.e072f184.jpg";